import React, { useCallback, useRef } from 'react';

import { useSharePanelStore } from 'src/common/store/share.store';
import { ShareThumbnailPickerOverlay } from './picker.overlay';
import { ShareThumbnailHoverOverlay } from './hover.overlay';
import FileDropzone from 'src/common/FileDropzone';
import { Nullable } from 'src/types/nullable.type';

export const ShareThumbnailOverlay = ({ isNeueActive }: { isNeueActive: boolean }) => {
  const { selectedImageUrl, showThumbnailSlider, uploadedFile, setUploadedFile } = useSharePanelStore((state) => ({
    selectedImageUrl: state.selectedImageUrl,
    showThumbnailSlider: state.showThumbnailSlider,
    uploadedFile: state.uploadedThumbnailFile,
    setUploadedFile: state.setUploadedFile,
  }));
  const inputRef = useRef<Nullable<HTMLElement>>(null);

  const onUploadClick = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  }, []);

  const onFilesUpdate = useCallback(
    (files: File[]) => {
      if (files && files.length > 0) {
        const [updatedFile] = files;
        setUploadedFile(updatedFile);
      }
    },
    [setUploadedFile]
  );

  const doesImageNeedConfirmation = Boolean(uploadedFile) || showThumbnailSlider || selectedImageUrl;

  return (
    <>
      {doesImageNeedConfirmation ? (
        <ShareThumbnailPickerOverlay onUploadClicked={onUploadClick} />
      ) : (
        <ShareThumbnailHoverOverlay isNeueActive={isNeueActive} onUploadClicked={onUploadClick} />
      )}

      <div className='hidden'>
        <FileDropzone
          accept={['image/*']}
          type='file'
          className='file-dropzone'
          multiple={false}
          onFilesUpdate={onFilesUpdate}
          resetOnSuccess={true}
          dropzoneClasses={null}
          inputRef={inputRef}
        />
      </div>
    </>
  );
};
